define(
    '../../widgets/product-imagesset/main',[
        'jquery',
        'modules/magnify-image-box',
        'jquery-zoom'
    ],
    function ($, MagnifyImageBox, jQueryZoom) {
        return function () {
            $('body').on('click', '.product-images-set__thumbnails__item', function (e) {
                if (!Modernizr.touch) { /* #2259 scroll hijack mobile bug */
                    zoomImg = $('.img', this).attr('data-src-hd');
                    $('.product-images-set__main-image').trigger('zoom.destroy');
                    $('.product-images-set__main-image').zoom({url:zoomImg});
                }
            });

            $('body').on('click', '.product-view__thumbnails__item', function (e) {

                if (!Modernizr.touch) { /* #2259 scroll hijack mobile bug */
                    var zoomImg = $('.product-images-set__main-image .img').attr('data-src-hd');
                    $('.product-images-set__main-image').trigger('zoom.destroy');
                    $('.product-images-set__main-image').zoom({ url: zoomImg });
                }
            });
     
            $('body').on('click', '.zoomImg, .product-images-set__main-image a', function (e) {
                e.preventDefault();
                OpenmagnifyImageBox();
            });

            OpenmagnifyImageBox =  function(showSrc){
                var target = $('.product-images-set__main-image a');
                var mainImgSrc = target.parent().find('.img').attr('data-src-hd');
                imgList = target.closest('.product-images-set').find('.product-images-set__thumbnails').find('.img, .video').map(function () {
                    return {
                        isImage: $(this).attr('data-video-player-type') == null, 
                        isVideo: $(this).attr('data-video-player-type') != null,
                        src: $(this).attr('data-video-player-type') == null ? $(this).attr('data-src-hd') : $(this).attr('data-video-src'),
                        videoPlayerType: $(this).attr('data-video-player-type')
                    }
                }).get();

                var index = 0;
                for(var i=0; i < imgList.length; i++) {
                    if ((showSrc !== undefined && imgList[i].src === showSrc) || (showSrc === undefined && imgList[i].src === mainImgSrc)) {
                        index = i;
                        break;
                    }
                }

                var magnifyImageBox = new MagnifyImageBox(imgList, index);
                magnifyImageBox.show();
            };

        };
    }
);


